var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizTimer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "quiz_timer_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430 430",
    style: {
      enableBackground: "new 0 0 430 430"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".quiz_timer_svg__st0{fill:url(#quiz_timer_svg__SVGID_1_)}.quiz_timer_svg__st1{fill:#272727}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "quiz_timer_svg__SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.0037,
    y1: 159.3898,
    x2: 320.0064,
    y2: 159.3898,
    gradientTransform: "matrix(1 0 0 -1 0 429.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4690FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2CD4F2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "quiz_timer_svg__st0",
    d: "M306.3,326H123.7c-4.2,0-8.1-1.9-10.7-5.1c-2.6-3.2-3.5-7.4-2.6-11.5c5.8-23.9,17.1-45.4,32.8-62 c17.1-18.2,38.2-29.1,60.9-31.7c0.1,0,0.2,0,0.4,0c1.8-0.2,7.8-0.7,10.5-0.7s8.8,0.5,10.5,0.7c0.1,0,0.2,0,0.4,0 c22.7,2.6,44.8,14,62.4,32.2c17,17.6,28.2,39.8,31.6,62.6c0.6,3.9-0.6,7.8-3.2,10.8S310.3,326,306.3,326L306.3,326z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "quiz_timer_svg__st1",
    d: "M349,381H81.2c-6.6,0-12-5.4-12-12v-36c0-6.6,5.4-12,12-12H92c4.3-27.7,15.5-53.8,32.1-74.5 c11-13.6,23.9-24.3,38-31.8c-14.1-7.5-27-18.2-38-31.8c-16.8-20.8-28-47.1-32.2-75H81c-6.6,0-12-5.4-12-12V60c0-6.6,5.4-12,12-12 h267.8c6.6,0,12,5.4,12,12v36c0,6.6-5.4,12-12,12H338c-4.2,27.9-15.4,54.2-32.2,75c-11,13.6-23.9,24.3-38,31.8 c14.1,7.4,27,18.2,38,31.8c16.6,20.6,27.9,46.8,32.1,74.5H349c6.6,0,12,5.4,12,12v36C361,375.6,355.6,381,349,381L349,381z  M93.2,357H337v-12h-6.8c-1,0.2-1.9,0.4-2.9,0.4H102.6c-1,0-2-0.1-2.9-0.4h-6.5L93.2,357L93.2,357z M116.3,321h197.3 c-8.9-49.3-43.2-88.5-83.6-93.6c-6.3-0.8-11.1-6.2-11.1-12.6c0-6.4,4.8-11.8,11.1-12.6c40.5-5.2,74.9-44.6,83.7-94H116.2 c8.8,49.5,43.1,88.8,83.7,94c6.3,0.8,11.1,6.2,11.1,12.6c0,6.4-4.8,11.8-11.1,12.6C159.5,232.5,125.2,271.7,116.3,321z M233.1,225.9 C233.1,225.9,233,225.9,233.1,225.9C233,225.9,233,225.9,233.1,225.9z M196.9,203.6C196.9,203.6,196.8,203.6,196.9,203.6 C196.8,203.6,196.9,203.6,196.9,203.6z M93,84h243.8V72H93C93,72,93,84,93,84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizTimer);
export default __webpack_public_path__ + "static/media/quiz_timer.dd53605ea9a68e6b3a7e3f426879c4f7.svg";
export { ForwardRef as ReactComponent };